import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) =>
  createStyles({
    helpButton: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 25,
      height: 25,
      marginLeft: 15,
      padding: 0,
      border: 'none',
      borderRadius: '50%',
      background: theme.extraColors.helpButtonBackground,
      '&:hover': {
        cursor: 'pointer',
        background: theme.extraColors.helpButtonBackground,
      },
      '&:focus': {
        outline: 0,
      },
      '& span': {
        color: theme.extraColors.helpButtonText,
        fontSize: 18,
        fontWeight: 700,
      },
      [theme.breakpoints.down('xs')]: {
        position: 'absolute',
        top: 5,
        right: 5,
        background: theme.extraColors.helpButtonBackgroundMobile,
        '&:hover': {
          background: theme.extraColors.helpButtonBackgroundMobile,
        },
      },
    },
  }),
);

interface Props {
  onHelpClick: (props: boolean) => void;
}

const HelpButton: React.FC<Props> = ({ onHelpClick }) => {
  const classes = useStyles();

  return (
    <Button onClick={() => onHelpClick(true)} className={classes.helpButton}>
      ?
    </Button>
  );
};

export default HelpButton;
